import type { IErrorTrackingProvider } from './types';
import { NoopErrorTrackingProvider } from './noop_provider';
import { SentryErrorTrackingProvider } from './sentry_provider';
import { isSentryEnabled } from '@/lib/sentry';

let _provider: IErrorTrackingProvider | null = null;

export function getErrorTracker(): IErrorTrackingProvider {
  if (_provider) return _provider;
  _provider = isSentryEnabled()
    ? new SentryErrorTrackingProvider()
    : new NoopErrorTrackingProvider();
  return _provider;
}

export function isSentryActive(): boolean {
  return isSentryEnabled();
}

/** Reset cached provider — useful for tests. */
export function __resetErrorTracker(): void {
  _provider = null;
}
